import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';
import { JobImprovedDto } from '../model';

class ChatClient extends BaseClient {
  getChatJobImproved(chatId: number): AxiosPromise<JobImprovedDto> {
    return this.request({
      url: `${hosts.chatApi}/chat/${chatId}/job-improved/`,
      method: 'GET',
    });
  }
}

export const chatClient = new ChatClient();
